import type { ActionContext } from 'vuex'
import type { ActionClass, ContextState } from '../../../models'
import { CONTEXT_CONSTS } from '../../../store/context/context.consts'
import { mapToolStateToContext } from '../utils/map-tool-state-to-context'

export class SetStrictMatchingAction implements ActionClass {
  static execute(
    this: void,
    { state, commit }: ActionContext<ContextState, any>,
    strictMatching: boolean,
  ): void {
    const context = { strictMatching }

    commit(
      CONTEXT_CONSTS.mutations.setContext,
      state.currentFeature ? mapToolStateToContext(state, context) : context,
    )
  }
}
